import Swiper from 'swiper';

// init Swiper:
new Swiper('.posts-carousel__carousel', {
  slidesPerView: 'auto',
  spaceBetween: 25,
  watchOverflow: true,
  navigation: {
    nextEl: '.posts-carousel__navigation .swiper-button-next',
    prevEl: '.posts-carousel__navigation .swiper-button-prev',
  },
  pagination: {
    el: '.posts-carousel__navigation .swiper-pagination',
    clickable: true,
  },
});
